import { withLayout } from 'pages/Layout';
import ProfilePage from './ProfilePage';

export default withLayout('home', ProfilePage);
